import { MapPin, VolumeX } from "lucide-react";
import { useEffect } from "react";

import { CommandButton } from "../components/CommandButton";
import { StatusBlock } from "../components/StatusBlock";
import { useAudioCoordinator } from "../stores/audioCoordinator";
import styles from "../styles/App.module.css";

export function StartupPage() {
  const stopAll = useAudioCoordinator((state) => state.stopAll);
  const announce = useAudioCoordinator((state) => state.announce);
  const message = useAudioCoordinator((state) => state.message);

  useEffect(() => {
    document.title = "正在打开 - 我的听戏";
  }, []);

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <p className={styles.eyebrow}>我的听戏</p>
        <h1>正在打开</h1>
      </header>
      <main className={styles.main}>
        <StatusBlock message="正在打开我的听戏。" />
      </main>
      <p className={styles.liveRegion} aria-live="assertive">
        {message}
      </p>
      <nav className={styles.globalControls} aria-label="全局操作">
        <CommandButton
          icon={VolumeX}
          title="停止所有 App 声音"
          onClick={stopAll}
        />
        <CommandButton
          icon={MapPin}
          title="告诉我现在在哪"
          hint="这是本页最后一个按钮"
          onClick={() => {
            announce("你现在在：正在打开。");
          }}
        />
      </nav>
    </div>
  );
}
